// extracted by mini-css-extract-plugin
export default {"container":"InputMessage_container__6i0Tf","title":"InputMessage_title__bw-gO"};